import { useCallback, useState, useMemo } from 'react';
import UISearchInput from 'UIComponents/input/UISearchInput';
import ErrorBoundary from 'customer-data-objects-ui-components/ErrorBoundary';
import UniversalAssociationsSelectSearchPaneError from './UniversalAssociationsSelectSearchPaneError';
import UniversalAssociationsSelectSearchResults from './UniversalAssociationsSelectSearchResults';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../h... Remove this comment to see the full error message
import { useDebounce } from '../hooks/useDebounce';
import I18n from 'I18n';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../h... Remove this comment to see the full error message
import * as FilterAssociationsHelper from '../helpers/FilterAssociationsHelper';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ConnectReferenceResolvers from 'reference-resolvers/ConnectReferenceResolvers';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message

import SearchResultsReferenceResolverWrapper from './SearchResultsReferenceResolverWrapper';
import styled from 'styled-components';
import { KOALA } from 'HubStyleTokens/colors';
import { CONTACT_TYPE_ID, COMPANY_TYPE_ID, DEAL_TYPE_ID, TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import getLang from 'I18n/utils/getLang';
import UIScreenReaderOnly from 'UIComponents/text/UIScreenReaderOnly';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { NOTE, TASK, LOGGED_CALL, LOGGED_EMAIL, LOGGED_MEETING, LOGGED_LINKED_IN_MESSAGE, LOGGED_POSTAL_MAIL, LOGGED_SMS, LOGGED_WHATS_APP } from 'customer-data-objects/interaction/InteractionTypes';
import * as EngagementTypes from 'customer-data-objects/engagement/EngagementTypes';
import { ShinySkeletonText } from '../helpers/ShinySkeletonText';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PERMISSIONLESS_ACTIVITIES = [LOGGED_CALL, LOGGED_EMAIL, LOGGED_LINKED_IN_MESSAGE, LOGGED_POSTAL_MAIL, LOGGED_MEETING, LOGGED_SMS, LOGGED_WHATS_APP, NOTE, TASK, EngagementTypes.NOTE, EngagementTypes.TASK];
const StyledSearchWrapper = styled.div.withConfig({
  displayName: "UniversalAssociationsSelectSearchPane__StyledSearchWrapper",
  componentId: "sc-1df09mm-0"
})(["background-color:", ";"], ({
  shouldAddSearchBackground
}) => shouldAddSearchBackground && `${KOALA}`);
export const SearchPaneSkeleton = ({
  isSingleObjectType
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: "flex-column width-100",
    "data-test-id": "search-pane-skeleton",
    children: [/*#__PURE__*/_jsx(StyledSearchWrapper, {
      className: "p-all-2",
      shouldAddSearchBackground: isSingleObjectType,
      children: /*#__PURE__*/_jsx(UISearchInput, {
        placeholder: "",
        use: "on-dark",
        disabled: true
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "p-bottom-2 p-left-2 p-right-2 m-top-1 overflow-y-scroll",
      children: Array.from({
        length: 2
      }, (_, index) => /*#__PURE__*/_jsxs("div", {
        children: [!isSingleObjectType && /*#__PURE__*/_jsx(ShinySkeletonText, {}), /*#__PURE__*/_jsx(UICheckbox, {
          alignment: "center",
          className: "m-bottom-2",
          checked: true,
          readOnly: true,
          children: /*#__PURE__*/_jsx(ShinySkeletonText, {})
        })]
      }, index))
    })]
  });
};
const PLACEHOLDER_TRANSLATIONS = {
  [COMPANY_TYPE_ID]: 'universalAssociationsSelect.searchPane.placeholder.companies',
  [CONTACT_TYPE_ID]: 'universalAssociationsSelect.searchPane.placeholder.contacts',
  CUSTOM_OBJECT: 'universalAssociationsSelect.searchPane.placeholder.customObjects',
  [DEAL_TYPE_ID]: 'universalAssociationsSelect.searchPane.placeholder.deals',
  [TICKET_TYPE_ID]: 'universalAssociationsSelect.searchPane.placeholder.tickets'
};
const UniversalAssociationsSelectSearchPane = ({
  associationRecords,
  canEdit,
  currentUserCanCommunicateWithEngagement = true,
  emailRecipientsIds,
  engagementOrInteractionType,
  onToggleSelectAssociation,
  readOnly,
  resolver,
  selectedObjectTypeId,
  shouldAddSearchBackground,
  shouldDisableLastAssociation,
  shouldShowPopoverOpenMessage,
  setShouldShowPopoverOpenMessage
}) => {
  const [searchText, setSearchText] = useState('');
  const debouncedSearch = useDebounce(searchText);
  const handleSearch = useCallback(({
    target: {
      value
    }
  }) => {
    setSearchText(value);
  }, [setSearchText]);
  const selectedAssociationRecord = useMemo(() => {
    if (!selectedObjectTypeId) {
      return associationRecords;
    }
    return associationRecords.find(associationRecord => associationRecord.get('toObjectTypeId') === selectedObjectTypeId);
  }, [selectedObjectTypeId, associationRecords]);
  const AssociationOptions = useMemo(() => {
    if (selectedObjectTypeId) {
      const singularObjectName = selectedAssociationRecord.get('singularObjectName');
      return /*#__PURE__*/_jsx(SearchResultsReferenceResolverWrapper, {
        canEdit: canEdit,
        emailRecipientsIds: emailRecipientsIds,
        engagementOrInteractionType: engagementOrInteractionType,
        isSearching: !!debouncedSearch,
        onToggleSelectAssociation: onToggleSelectAssociation,
        singularObjectName: singularObjectName,
        readOnly: readOnly,
        resolver: resolver,
        searchText: debouncedSearch,
        selectedAssociationRecord: selectedAssociationRecord,
        selectedObjectTypeId: selectedObjectTypeId,
        shouldDisableLastAssociation: shouldDisableLastAssociation
      });
    }
    const searchResults = FilterAssociationsHelper.filterAssociations(associationRecords, debouncedSearch);
    return /*#__PURE__*/_jsx(UniversalAssociationsSelectSearchResults, {
      canEdit: canEdit,
      emailRecipientsIds: emailRecipientsIds,
      engagementOrInteractionType: engagementOrInteractionType,
      isSearching: !!debouncedSearch,
      onToggleSelectAssociation: onToggleSelectAssociation,
      readOnly: readOnly,
      searchResults: searchResults,
      searchText: searchText,
      shouldDisableLastAssociation: shouldDisableLastAssociation
    });
  }, [associationRecords, canEdit, debouncedSearch, emailRecipientsIds, engagementOrInteractionType, onToggleSelectAssociation, readOnly, resolver, searchText, selectedAssociationRecord, selectedObjectTypeId, shouldDisableLastAssociation]);
  const pluralObjectName = useMemo(() => {
    return selectedObjectTypeId ? selectedAssociationRecord.get('pluralObjectName') : I18n.text('universalAssociationsSelect.associations');
  }, [selectedAssociationRecord, selectedObjectTypeId]);
  const placeholder = useMemo(() => {
    if (!selectedObjectTypeId) {
      return I18n.text('universalAssociationsSelect.searchPane.placeholder.currentAssociations');
    }
    const message =
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    PLACEHOLDER_TRANSLATIONS[selectedObjectTypeId] || PLACEHOLDER_TRANSLATIONS.CUSTOM_OBJECT;

    // In German all nouns are capitalized regardless where there are in a sentence or phrase
    const properCasedPluralObjectName = getLang() === 'de' ? pluralObjectName : pluralObjectName.toLowerCase();
    return I18n.text(message, {
      pluralObjectName: properCasedPluralObjectName
    });
  }, [pluralObjectName, selectedObjectTypeId]);
  const renderedAccessibilityHeader = useMemo(() => {
    if (searchText) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "universalAssociationsSelect.accessibility.searchResults"
      });
    }
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "universalAssociationsSelect.accessibility.objects",
      options: {
        pluralObjectName
      }
    });
  }, [pluralObjectName, searchText]);
  const isPermissionlessActivity = PERMISSIONLESS_ACTIVITIES.includes(engagementOrInteractionType);
  const shouldEnableSearch = isPermissionlessActivity || currentUserCanCommunicateWithEngagement;
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    boundaryName: "UniversalAssociationsSelectSearchPaneError",
    ErrorComponent: UniversalAssociationsSelectSearchPaneError,
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex-column width-100",
      children: [/*#__PURE__*/_jsx(UITooltip, {
        disabled: shouldEnableSearch,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "universalAssociationsSelect.tooltipCommunicationPermissionErrorV2"
        }),
        children: /*#__PURE__*/_jsxs(StyledSearchWrapper, {
          className: "p-all-2",
          shouldAddSearchBackground: shouldAddSearchBackground,
          children: [/*#__PURE__*/_jsx(UISearchInput, {
            "aria-describedby": `universal-associations-select-search-${selectedObjectTypeId}`,
            autoFocus: true,
            "data-selenium-test": "association-search",
            disabled: !shouldEnableSearch,
            onChange: handleSearch,
            placeholder: placeholder,
            use: "on-dark",
            onBlur: () => {
              if (setShouldShowPopoverOpenMessage) {
                setShouldShowPopoverOpenMessage(false);
              }
            },
            value: searchText
          }), /*#__PURE__*/_jsxs(UIScreenReaderOnly, {
            children: [/*#__PURE__*/_jsx("div", {
              id: `universal-associations-select-search-${selectedObjectTypeId}`,
              children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: shouldShowPopoverOpenMessage ? 'universalAssociationsSelect.accessibility.popoverOpened' : 'universalAssociationsSelect.accessibility.search',
                options: {
                  pluralObjectName
                }
              })
            }), /*#__PURE__*/_jsx("h3", {
              children: renderedAccessibilityHeader
            })]
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "p-bottom-2 p-left-2 p-right-2 m-top-1 overflow-y-scroll",
        children: AssociationOptions
      })]
    })
  });
};
export const connectResolver = ConnectReferenceResolvers((resolvers, {
  selectedObjectTypeId,
  associationRecords
}) => {
  if (!selectedObjectTypeId || !associationRecords) {
    return {};
  }
  const {
    resolverFactory,
    resolversCache
  } = resolvers.CUSTOM_OBJECT();
  const selectedAssociationRecord = associationRecords.find(associationRecord => associationRecord.get('toObjectTypeId') === selectedObjectTypeId);
  const primaryDisplayLabelGetter = selectedAssociationRecord.get('primaryDisplayLabelGetter');
  const secondaryDisplayLabelGetter = selectedAssociationRecord.get('secondaryDisplayLabelGetter');
  const options = {
    formatterOptions: {
      getters: {
        getLabel: primaryDisplayLabelGetter,
        getDescription: secondaryDisplayLabelGetter
      }
    }
  };
  const CustomObjectResolver = resolverFactory(selectedObjectTypeId, options);
  const resolver = CustomObjectResolver(resolversCache);
  return {
    resolver
  };
});
export default connectResolver(UniversalAssociationsSelectSearchPane);